import React, { useEffect, useRef, useState } from "react";
import "./edit-profile.scss";
import DocumentContainer from "../UI Component/DocumentViewer/DocumentCotainer";
import TemplateUpload from "./TemplateUpload";
import swal from "sweetalert";
import { CancelToken } from "axios";
import { getSignedUrl } from "../../Util/API Calls/SignedAPIUrl";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import Resizer from "react-image-file-resizer";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { UPLOADING_FOR } from "../AdminEditProfile/constant";
import Loader from "../UI Component/Loader/Loader";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

const UploadTemplateForm = (props) => {
  const {
    uploadingFor,
    use_case,
    doctor_id,
    clinic_id,
    setClearSelectedFile,
    setDataKey,
  } = props;
  const file = [];
  const [percentage, setPercentage] = useState(0);
  const [selectedFile, setSelectedFile] = useState();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [error, setError] = useState(null);
  const [loader, setLoader] = useState(false);
  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "",
    fileType: "",
  });
  const cancelFileUpload = useRef();

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  useEffect(() => {
    if (typeof setClearSelectedFile === "function") {
      setClearSelectedFile(clearSelectedFile);
    }
    if (uploadingFor === UPLOADING_FOR.OTHER_CLINIC) {
      if (props?.title === "Footer Template") {
        setUploadedFile(
          props?.values?.prescription_data?.doctor_profile_details
            ?.footer_template
        );
      } else if (props?.title === "Header Template") {
        setUploadedFile(
          props?.values?.prescription_data?.doctor_profile_details
            ?.header_template
        );
      } else {
        setUploadedFile(null);
      }
    } else {
      if (props?.title === "Footer Template") {
        setUploadedFile(props?.values?.doctor_profile_details?.footer_template);
      } else if (props?.title === "Header Template") {
        setUploadedFile(props?.values.doctor_profile_details?.header_template);
      } else if (props?.title === "Clinic/Hospital Logo") {
        setUploadedFile(props.uploadLogo);
      } else {
        setUploadedFile(null);
      }
    }
  }, [props]);

  useEffect(() => {
    setError(props?.error);
  }, [props?.error]);

  const clearSelectedFile = () => {
    setSelectedFile(null);
  };

  const imageSelectHandler = async (image, title) => {
    if (props?.values?.doctor_profile_details?.header_template == {}) {
      props.setFieldValue("doctor_profile_details.header_template", image);
    }
    if (props?.values?.doctor_profile_details?.footer_template == {}) {
      props.setFieldValue("doctor_profile_details.footer_template", image);
    }

    if (image && image?.value) {
      if (title === "Header Template" || title === "Footer Template") {
        if (image?.size > 1) {
          setSelectedFile(image);
          Resizer.imageFileResizer(
            image.fileDate,
            1052,
            230,
            "JPEG",
            100,
            0,
            (uri) => {
              let imageData = {};
              imageData.value = uri;
              imageData.name = image.name;
              imageData.size = image.size;
              imageData.fileDate = image.fileDate;
              submitTemplate(imageData, title);
            },
            "base64",
            1052,
            230
          );
        } else {
          setSelectedFile(image);
          submitTemplate(image, title);
        }
      } else if (title === "Clinic/Hospital Logo") {
        if (image?.size > 1) {
          setSelectedFile(image);
          Resizer.imageFileResizer(
            image.fileDate,
            1052,
            230,
            "JPEG",
            100,
            0,
            (uri) => {
              let imageData = {};
              imageData.value = uri;
              imageData.name = image.name;
              imageData.size = image.size;
              imageData.fileDate = image.fileDate;
              submitTemplate(imageData, title);
            },
            "base64",
            60,
            60
          );
        } else {
          setSelectedFile(image);
          submitTemplate(image, title);
        }
      }
    }
  };

  const submitTemplate = async (image, title, setState) => {
    if (image && image.value) {
      const option = {
        onUploadProgress: (ProgressEvent) => {
          const { loaded, total } = ProgressEvent;
          let percent = Math.floor((loaded * 100) / total);

          setPercentage(percent);
        },
        cancelToken: new CancelToken(
          (cancel) => (cancelFileUpload.current = cancel)
        ),
      };
      Object.entries(image).forEach(([key, value]) => {
        if (key === "fileDate") {
          value.option = option;
        }
      });
      let payload = {
        file_size: image.size,
        doc_title: image.name,
        user_type: localStorage.getItem("user_type"),
        use_case: use_case ? use_case : "upload-document-rev1",
      };
      if (uploadingFor === UPLOADING_FOR.OTHER_CLINIC) {
        payload = {
          ...payload,
          doctor_id: doctor_id,
          clinic_id: clinic_id,
        };
      }
      let signedUrl = await getSignedUrl(
        payload,
        image.fileDate
        // option
      );
      if (uploadingFor === UPLOADING_FOR.OTHER_CLINIC) {
        let key = signedUrl.fields.key;
        setDataKey(key);
      }
      if (!signedUrl) {
        alert("Please upload only jpeg,jpg,png,file");
      } else {
        getLogoUrl(image, title);
      }
    }
  };

  const getLogoUrl = (image, title) => {
    setLoader(true);
    let params = {};
    if (localStorage.getItem("hospital_id")) {
      params["hospital_id"] = localStorage.getItem("hospital_id");
    }
    if (title === "Header Template") {
      props.setUploadHeaderError(true);
      params["header_template"] = {
        name: image?.name,
        value: image?.value,
      };
    } else if (title === "Footer Template") {
      props.setUploadFooterError(true);
      params["footer_template"] = {
        name: image?.name,
        value: image?.value,
      };
    } else {
      props.setUploadLogoError(true);
      params["hospital_logo_path"] = {
        name: image?.name,
        value: image?.value,
      };
    }
    if (uploadingFor === UPLOADING_FOR.OTHER_CLINIC) {
      params = {
        ...params,
        doctor_id: doctor_id,
        clinic_id: clinic_id,
        clinic_doctor_preview: true,
      };
    } else {
      params = {
        ...params,
        doctor_id: userId,
        clinic_doctor_preview: false,
      };
    }

    afterLoginApiAxios
      .post(
        "doctor/get-hospital-logo-preview",
        {
          ...params,
          staff_id: staffId,
        },
        {
          headers: { authorization: localStorage.getItem("id_token") },
        }
      )
      .then((response) => {
        setLoader(false);
        if (response?.status === 200) {
          if (response.data.statusCode !== 200) {
            setLoader(false);
            setSelectedFile(null);
            swal({
              title:
                "Unable to Upload file. Please check file format and try again",
              text: "",
              icon: "error",
              button: "Okay",
            });
            if (title === "Header Template") {
              props.setUploadHeaderError(false);
            } else if (title === "Footer Template") {
              props.setUploadFooterError(false);
            } else {
              props.setUploadLogoError(false);
            }
          } else {
            if (title === "Header Template") {
              props.setFieldValue(
                "doctor_profile_details.header_template",
                response?.data?.header_template
              );
              props.setUploadHeaderError(false);
              props.setUploadTemplate(response?.data?.header_template);
            } else if (title === "Footer Template") {
              props.setUploadFooterError(false);
              props.setFieldValue(
                "doctor_profile_details.footer_template",
                response?.data?.footer_template
              );
              props.setUploadFooterTemplate(response?.data?.footer_template);
            } else {
              props.setUploadLogoError(false);
              props.setUploadLogo(response?.data?.hospital_logo);
            }
          }
        } else {
          setSelectedFile(null);
          setLoader(false);
          swal({
            title:
              "Unable to Upload file. Please check file format and try again",
            text: "",
            icon: "error",
            button: "Okay",
          });
          if (title === "Header Template") {
            props.setUploadHeaderError(false);
          } else if (title === "Footer Template") {
            props.setUploadFooterError(false);
          } else {
            props.setUploadLogoError(false);
          }
        }
      })
      .catch((error) => {
        setLoader(false);
        setSelectedFile(null);
        alert("Please try again");
        if (title === "Header Template") {
          props.setUploadHeaderError(false);
        } else if (title === "Footer Template") {
          props.setUploadFooterError(false);
        } else {
          props.setUploadLogoError(false);
        }
        C2CConsole.log(error);
      });
  };

  const cancelUpload = () => {
    setPercentage(0);
    setSelectedFile(null);
    setUploadedFile(null);
    if (props.title === "Footer Template") {
      props.setUploadFooterTemplate({});
      props.setUploadFooterError(false);
      if (uploadingFor === UPLOADING_FOR.OTHER_CLINIC) {
        props.values.prescription_data.doctor_profile_details.footer_template =
          null;
      } else {
        props.values.doctor_profile_details.footer_template = null;
      }
    } else if (props.title === "Header Template") {
      setUploadedFile(props.uploadTemplate);
      props.setUploadTemplate({});
      props.setUploadHeaderError(false);
      if (uploadingFor === UPLOADING_FOR.OTHER_CLINIC) {
        props.values.prescription_data.doctor_profile_details.header_template =
          null;
      } else {
        props.values.doctor_profile_details.header_template = null;
      }
    } else {
      setUploadedFile(props.uploadLogo);
      props.setUploadLogo({});
      props.setUploadLogoError(false);
    }
    setError("");
    swal({
      title: "Deleted Successfully",
      text: "File deleted successfully",
      type: "success",
    });
  };
  const renderDocument = (width) => {
    if (fileDetails?.documentShow) {
      return (
        <DocumentContainer
          cancelHandler={() => closeNotification()}
          url={fileDetails.fileURL}
          fileName={fileDetails.fileName}
          fileType={fileDetails.fileType}
          width={width || ""}
        />
      );
    }
  };
  const viewDocument = ({ fileURL, fileName, fileType }) => {
    setFileDetails({
      documentShow: true,
      fileURL: fileURL,
      fileName: fileName,
      fileType: fileType,
    });
  };

  const closeNotification = () => {
    setFileDetails({
      documentShow: false,
      fullView: false,
      fileName: "",
      fileURL: "",
      fileType: "",
    });
  };
  return (
    <>
      {loader ? <Loader /> : ""}
      <div className={props.title != "Clinic/Hospital Logo" ? "" : "w-100"}>
        {props.title != "Clinic/Hospital Logo" && (
          <div className="row col-12 pt-2 form_container">
            UPLOAD {props.title}
          </div>
        )}
        <div
          className={`personal_details_row ${
            props.title != "Clinic/Hospital Logo" ? "" : "mt-2"
          } `}
        >
          <TemplateUpload
            label={props.title}
            imageSelectHandler={imageSelectHandler}
            file={file}
            actions={{
              viewDocumentAction: viewDocument,
            }}
            selectedFile={selectedFile}
            uploadedFile={uploadedFile}
            percentage={percentage}
            cancelUpload={cancelUpload}
            fileValidationLabel={props.fileValidationLabel}
            error={error}
          />
          {renderDocument("98%")}
        </div>
      </div>
    </>
  );
};
export default UploadTemplateForm;
